import { connect, MapDispatchToProps } from 'react-redux';
import { Props } from './DonatePointsPopup';
import { donatePoints } from '../../../../actions/donations';

export type DispatchProps = Pick<Props, 'donatePoints'>;
export type OwnProps = Omit<Props, keyof DispatchProps>;

const mapStateToProps = undefined;
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  donatePoints,
};

export default connect(mapStateToProps, mapDispatchToProps);
